(function () {
  if (customElements.get('announcement-ticker')) return;

  class AnnouncementTicker extends HTMLElement {
    connectedCallback() {
      this._track = this.querySelector('.announcement-ticker__track');
      if (!this._track) return;

      // Clone all items so the loop is seamless
      const originals = Array.from(this._track.children);
      originals.forEach((item) => {
        const clone = item.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        this._track.appendChild(clone);
      });

      // Pause on hover
      this.addEventListener('mouseenter', () => {
        this._track.style.animationPlayState = 'paused';
      });
      this.addEventListener('mouseleave', () => {
        this._track.style.animationPlayState = 'running';
      });

      // Pause when tab is hidden
      document.addEventListener('visibilitychange', () => {
        this._track.style.animationPlayState = document.hidden ? 'paused' : 'running';
      });
    }
  }

  customElements.define('announcement-ticker', AnnouncementTicker);
})();
